import React, { useEffect, useState } from 'react';
import { adminApi } from '../../api/client';
import { Briefcase, Building2, FileText, Users, Clock, Mail } from 'lucide-react';

const cards = [
  { key: 'services', label: 'Xidmət', icon: Briefcase, color: '#17b4b4' },
  { key: 'projects', label: 'Layihə', icon: Building2, color: '#0ea5e9' },
  { key: 'blog', label: 'Bloq yazısı', icon: FileText, color: '#8b5cf6' },
  { key: 'doctors', label: 'Həkim', icon: Users, color: '#ec4899' },
  { key: 'timeline', label: 'Karyera qeydi', icon: Clock, color: '#f59e0b' },
  { key: 'contacts', label: 'Müraciət', icon: Mail, color: '#10b981' },
];

export default function Dashboard() {
  const [counts, setCounts] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      const out = {};
      for (const c of cards) {
        try {
          const data = await adminApi.list(c.key);
          out[c.key] = data.length;
        } catch (ex) {
          console.error(`Failed to load ${c.key}:`, ex);
          out[c.key] = 0;
        }
      }
      setCounts(out);
      setLoading(false);
    })();
  }, []);

  return (
    <div>
      <h1 style={{ fontSize: 24, fontWeight: 700, margin: '0 0 6px' }}>Hoş gəldiniz</h1>
      <p style={{ color: '#6b7280', margin: '0 0 26px', fontSize: 14 }}>Saytınızı buradan idarə edin.</p>
      {loading ? (
        <div style={{ padding: 40, textAlign: 'center', color: '#6b7280' }}>Yüklənir...</div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 16 }}>
          {cards.map((c) => (
            <div key={c.key} style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, padding: 18 }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
                <div style={{ width: 40, height: 40, borderRadius: 8, background: c.color + '20', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <c.icon size={20} color={c.color} />
                </div>
                <span style={{ fontSize: 26, fontWeight: 700 }}>{counts[c.key] ?? '–'}</span>
              </div>
              <div style={{ fontSize: 13, color: '#6b7280', fontWeight: 500 }}>{c.label} sayı</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
